import { FETCH_USERS_PAGINATED } from '@/store/actionTypes'

export const FETCH_ORG_USERS = `${FETCH_USERS_PAGINATED}_FETCH_ORG_USERS`
export const FETCH_ORG_USERS_SUCCESS = `${FETCH_ORG_USERS}_SUCCESS`

export const DELETE_USER = 'organization/user/DELETE'
export const DELETE_USER_SUCCESS = `${DELETE_USER}_SUCCESS`

export const SET_FILTER_ORG_USER = 'SET_FILTER_ORG_USER'
export const SET_ORG_USERS_SORTING_STATE = 'SET_ORG_USERS_SORTING_STATE'
export const SET_EDIT_ORG_USER = 'SET_EDIT_ORG_USER'
export const RESET_ORG_USERS_PAGINATION_STATE = 'RESET_ORG_USERS_PAGINATION_STATE'
